import { Link as MuiLink, Typography } from '@mui/material'
import { useEffect } from 'react'
import { LoginForm, useAuthState, useCheckAuth, useTranslate } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../auth/AuthShell'
import OAuthButtons from '../auth/OAuthButtons'

const Login = () => {
  const { authenticated } = useAuthState()
  const translate = useTranslate()
  const checkAuth = useCheckAuth()
  const navigate = useNavigate()

  // What react-admin's <Login> frame did for us: an already-signed-in visitor
  // is sent to the dashboard instead of being shown the form. We render our
  // own frame (AuthShell) so we must keep this.
  useEffect(() => {
    checkAuth({}, false)
      .then(() => navigate('/'))
      .catch(() => {
        // not authenticated — stay on the login page
      })
  }, [checkAuth, navigate])

  // Handle external redirect after successful login (e.g., from /checkout)
  useEffect(() => {
    if (authenticated) {
      const externalRedirect = localStorage.getItem('loginRedirect')
      if (externalRedirect) {
        localStorage.removeItem('loginRedirect')
        // Redirect to the external URL (outside VetPo SPA)
        window.location.href = externalRedirect
      }
    }
  }, [authenticated])

  return (
    <AuthShell
      title={translate('pos.login.title')}
      subtitle={translate('pos.login.subtitle')}
      footer={
        <>
          <MuiLink
            component="button"
            variant="body2"
            underline="hover"
            onClick={(e) => {
              e.preventDefault()
              window.location.href = '/vet-portal/#/forgot-password'
            }}
          >
            {translate('pos.login.forgot_password')}
          </MuiLink>
          <Typography variant="body2" color="text.secondary">
            {translate('pos.login.no_account')}{' '}
            <MuiLink
              component="button"
              variant="body2"
              underline="hover"
              sx={{ verticalAlign: 'baseline' }}
              onClick={(e) => {
                e.preventDefault()
                window.location.href = '/signup'
              }}
            >
              {translate('pos.login.sign_up')}
            </MuiLink>
          </Typography>
        </>
      }
    >
      {/* LoginForm hard-codes a 300px content box with its own padding;
          let it fill the shell so inputs, the button and the OAuth row
          share one left and right edge. */}
      <LoginForm
        sx={{
          '& .RaLoginForm-content': { width: 'auto', p: 0, pb: '0 !important' },
          '& .RaLoginForm-button': { mt: 1, py: 1.25 },
        }}
      />
      <OAuthButtons />
    </AuthShell>
  )
}

export default Login
